import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";

function XmesiYgraneMarketplace({ data, titolo, displayTitolo, settings }) {
  let dataset = [];
  let keyToLabel = {};

  if (settings.series["smarrito"]) {
    keyToLabel.smarrito = "a. smarrito";
  }
  if (settings.series["danneggiato"]) {
    keyToLabel.danneggiato = "a. danneggiato";
  }
  if (settings.series["firma"]) {
    keyToLabel.firma = "firma disconosciuta";
  }
  if (settings.series["ritardo"]) {
    keyToLabel.ritardo = "ritardo";
  }
  if (settings.series["notdeposito"]) {
    keyToLabel.notdeposito = "notifica deposito";
  }
  if (settings.series["notpoint"]) {
    keyToLabel.notpoint = "notifica point";
  }

  if (data.dataSet) {
    dataset = data.dataSet;
  }
  console.log("dataset", dataset);

  let mutantValueFormatter = (value) => value;

  if (settings.robaDaSommare === "ordini") {
    mutantValueFormatter = (value) => (!value ? 0 : value);
  } else if (settings.robaDaSommare === "importo") {
    mutantValueFormatter = (value) =>
      !value
        ? 0
        : value
            .toString()
            .replace(".", ",")
            .replace(/\d(?=(?:(?:\d{3})+),)/g, (match) => `${match}.`) + " €";
  }

  const colors = {
    smarrito: "#ff9800",
    danneggiato: "#009688",
    firma: "#1565c0",
    ritardo: "#9c27b0",
    notdeposito: "#b71c1c",
    notpoint: "#e91e63",
  };

  const xData = dataset.map((row) => new Date(row.year_month_combined));

  const customize = {
    height: 700,
    /* legend: { hidden: true }, */
    margin: { top: 5 },
    stackingOrder: "descending",
    xAxis: [
      {
        data: xData,
        scaleType: "time",
        valueFormatter: (v) =>
          v.toLocaleString("it-IT", {
            year: "2-digit",
            month: "2-digit",
          }),
      },
    ],
  };

  let stackStrategy;

  if (settings.stack) {
    stackStrategy = {
      stack: "total",
      area: true,
      stackOffset: "none", // To stack 0 on top of others
      stackOrder: "reverse",
    };
  }

  const series = Object.keys(keyToLabel).map((key) => ({
    dataKey: key,
    label: keyToLabel[key],
    valueFormatter: (v) => mutantValueFormatter(v),
    /* connectNulls: true, */
    color: colors[key],
    showMark: false,
    ...stackStrategy,
  }));

  console.log("series", series);

  if (data) {
    return (
      <div>
        {titolo && displayTitolo && (
          <div className="tc sfondoColChiaro pa2 b">{titolo}</div>
        )}
        {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
        <div className="pa2 flex flex-wrap items-center">
          <LineChart series={series} dataset={dataset} {...customize} />
        </div>
      </div>
    );
  } else {
    return <div>no data</div>;
  }
}

export default XmesiYgraneMarketplace;
